export const ActivityData = {
	date: {
		min: '2022-11-02T23:00:00.000Z',
		max: '2022-11-03T23:00:00.000Z',
	},
	map: {
		origin: {
			name: 'DUROC',
			city: 'Ait Amira',
			country: 'Maroc',
			point: ['30.1752667', '-9.4867182'],
		},
		destination: {
			name: 'BIRCHINGTON',
			city: 'BIRCHINGTON',
			country: 'UK',
			point: ['51.373347', '1.306532'],
		},
		shipmentLegs: [
			['30.1752667', '-9.4867182'],
			['33.2752667', '-11.4867182'],
			['47.2752667', '-8.4867182'],
			['51.373347', '1.306532'],
		],
		data: [
			{
				point: [47.2752667, -8.4867182],
				date: '2022-11-02T23:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [33.2752667, -11.4867182],
				date: '2022-11-02T23:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 91,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.38,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4337734237288, -9.63661361016949],
				date: '2022-11-02T23:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4303729852941, -9.63260089705882],
				date: '2022-11-02T23:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 68.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.67,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4303729852941, -9.63260089705882],
				date: '2022-11-02T23:15:12.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 65.4,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 7.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-02T23:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [31.7268178457711, -8.21892035820896],
				date: '2022-11-02T23:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.19,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4347122183908, -9.63764631034483],
				date: '2022-11-02T23:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.11,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4347122183908, -9.63764631034483],
				date: '2022-11-02T23:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.56,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4335443090909, -9.63640473636364],
				date: '2022-11-02T23:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-02T23:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-02T23:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4335443090909, -9.63640473636364],
				date: '2022-11-02T23:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.39,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-02T23:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 91,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.44,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4323656923077, -9.63949108974359],
				date: '2022-11-02T23:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4337734237288, -9.63661361016949],
				date: '2022-11-02T23:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4337734237288, -9.63661361016949],
				date: '2022-11-02T23:44:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.17,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-02T23:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [31.7268178457711, -8.21892035820896],
				date: '2022-11-02T23:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.22,
						Unit: 'F',
					},
				],
			},
			{
				point: [31.7268178457711, -8.21892035820896],
				date: '2022-11-02T23:52:51.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 10.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T00:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T00:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T00:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 91,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.54,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T00:04:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.89,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4323656923077, -9.63949108974359],
				date: '2022-11-03T00:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.94,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T00:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.4345481262136, -9.63740822330097],
				date: '2022-11-03T00:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.23,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4367763773585, -9.63432795283019],
				date: '2022-11-03T00:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T00:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T00:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4323656923077, -9.63949108974359],
				date: '2022-11-03T00:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 73.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.94,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4323656923077, -9.63949108974359],
				date: '2022-11-03T00:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 92,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.1,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4345348039216, -9.6378221372549],
				date: '2022-11-03T00:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.97,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T00:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [31.7355491098901, -8.20329932967033],
				date: '2022-11-03T00:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345481262136, -9.63740822330097],
				date: '2022-11-03T00:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.23,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4367763773585, -9.63432795283019],
				date: '2022-11-03T01:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T01:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T01:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T01:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.57,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345348039216, -9.6378221372549],
				date: '2022-11-03T01:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T01:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [31.7355491098901, -8.20329932967033],
				date: '2022-11-03T01:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.9,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345481262136, -9.63740822330097],
				date: '2022-11-03T01:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.26,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345481262136, -9.63740822330097],
				date: '2022-11-03T01:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.9,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.44,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4367763773585, -9.63432795283019],
				date: '2022-11-03T01:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T01:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T01:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4367763773585, -9.63432795283019],
				date: '2022-11-03T01:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.8,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.44,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T01:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.6,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4322627471264, -9.63937187356322],
				date: '2022-11-03T01:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.16,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345348039216, -9.6378221372549],
				date: '2022-11-03T01:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345348039216, -9.6378221372549],
				date: '2022-11-03T01:44:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.11,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T01:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [31.7355491098901, -8.20329932967033],
				date: '2022-11-03T01:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.56,
						Unit: 'F',
					},
				],
			},
			{
				point: [31.7355491098901, -8.20329932967033],
				date: '2022-11-03T01:52:51.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 72.8,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 8.72,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T02:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T02:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T02:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T02:02:21.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.89,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4322627471264, -9.63937187356322],
				date: '2022-11-03T02:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.22,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T02:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.4377333636364, -9.63424901136364],
				date: '2022-11-03T02:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.07,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4374782542373, -9.63557838983051],
				date: '2022-11-03T02:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T02:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T02:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4322627471264, -9.63937187356322],
				date: '2022-11-03T02:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.24,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4322627471264, -9.63937187356322],
				date: '2022-11-03T02:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 92,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.8,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.83,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4336312, -9.63644369230769],
				date: '2022-11-03T02:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.91,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T02:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [32.2518478449198, -7.9671977459893],
				date: '2022-11-03T02:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.43,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4377333636364, -9.63424901136364],
				date: '2022-11-03T02:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.2,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4374782542373, -9.63557838983051],
				date: '2022-11-03T03:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T03:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T03:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.43584555, -9.639373325],
				date: '2022-11-03T03:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.6,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336312, -9.63644369230769],
				date: '2022-11-03T03:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.97,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T03:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [32.2518478449198, -7.9671977459893],
				date: '2022-11-03T03:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.58,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4377333636364, -9.63424901136364],
				date: '2022-11-03T03:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.29,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4377333636364, -9.63424901136364],
				date: '2022-11-03T03:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.33,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4374782542373, -9.63557838983051],
				date: '2022-11-03T03:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T03:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T03:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4374782542373, -9.63557838983051],
				date: '2022-11-03T03:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.4,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.33,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.43584555, -9.639373325],
				date: '2022-11-03T03:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336312, -9.63644369230769],
				date: '2022-11-03T03:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.03,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336312, -9.63644369230769],
				date: '2022-11-03T03:44:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T03:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [32.2518478449198, -7.9671977459893],
				date: '2022-11-03T03:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 72.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.55,
						Unit: 'F',
					},
				],
			},
			{
				point: [32.2518478449198, -7.9671977459893],
				date: '2022-11-03T03:52:51.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 8.61,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T04:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.43584555, -9.639373325],
				date: '2022-11-03T04:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.66,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.43584555, -9.639373325],
				date: '2022-11-03T04:04:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.89,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4333403548387, -9.63609744086021],
				date: '2022-11-03T04:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335691938775, -9.63645019387755],
				date: '2022-11-03T04:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T04:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T04:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4332895797101, -9.63601052173913],
				date: '2022-11-03T04:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T04:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [33.0715879954338, -7.59558210045662],
				date: '2022-11-03T04:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.5,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4333403548387, -9.63609744086021],
				date: '2022-11-03T04:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335691938775, -9.63645019387755],
				date: '2022-11-03T05:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T05:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T05:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T05:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.66,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4332895797101, -9.63601052173913],
				date: '2022-11-03T05:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T05:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [33.0715879954338, -7.59558210045662],
				date: '2022-11-03T05:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.94,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4333403548387, -9.63609744086021],
				date: '2022-11-03T05:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4333403548387, -9.63609744086021],
				date: '2022-11-03T05:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4335691938775, -9.63645019387755],
				date: '2022-11-03T05:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.91,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T05:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T05:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4335691938775, -9.63645019387755],
				date: '2022-11-03T05:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.33,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T05:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4319070493827, -9.63945818518519],
				date: '2022-11-03T05:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.37,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4332895797101, -9.63601052173913],
				date: '2022-11-03T05:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4332895797101, -9.63601052173913],
				date: '2022-11-03T05:44:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.89,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T05:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [33.0715879954338, -7.59558210045662],
				date: '2022-11-03T05:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.67,
						Unit: 'F',
					},
				],
			},
			{
				point: [33.0715879954338, -7.59558210045662],
				date: '2022-11-03T05:52:51.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 8.22,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T06:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T06:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 90,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.6,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.440671, -9.644614],
				date: '2022-11-03T06:04:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.67,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4319070493827, -9.63945818518519],
				date: '2022-11-03T06:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.37,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4330055, -9.6359498125],
				date: '2022-11-03T06:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.95,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T06:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.4339412368421, -9.63697955263158],
				date: '2022-11-03T06:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339960222222, -9.63705042222222],
				date: '2022-11-03T06:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T06:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.4319070493827, -9.63945818518519],
				date: '2022-11-03T06:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.4,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4319070493827, -9.63945818518519],
				date: '2022-11-03T06:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 92,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.4,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.39,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.43345575, -9.63624947222222],
				date: '2022-11-03T06:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4330055, -9.6359498125],
				date: '2022-11-03T06:44:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 67,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.95,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T06:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [33.8308806178571, -7.10037751785714],
				date: '2022-11-03T06:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.36,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339412368421, -9.63697955263158],
				date: '2022-11-03T06:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.35,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339960222222, -9.63705042222222],
				date: '2022-11-03T07:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.84,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T07:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T07:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T07:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.43345575, -9.63624947222222],
				date: '2022-11-03T07:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4330055, -9.6359498125],
				date: '2022-11-03T07:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 67.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.98,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4330055, -9.6359498125],
				date: '2022-11-03T07:15:12.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 7.06,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T07:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [33.8308806178571, -7.10037751785714],
				date: '2022-11-03T07:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 71.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.23,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339412368421, -9.63697955263158],
				date: '2022-11-03T07:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.35,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339412368421, -9.63697955263158],
				date: '2022-11-03T07:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4339960222222, -9.63705042222222],
				date: '2022-11-03T07:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T07:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.954255, 4.240674],
				date: '2022-11-03T07:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4339960222222, -9.63705042222222],
				date: '2022-11-03T07:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.22,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T07:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4342404098361, -9.642593],
				date: '2022-11-03T07:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.37,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.43345575, -9.63624947222222],
				date: '2022-11-03T07:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.16,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.43345575, -9.63624947222222],
				date: '2022-11-03T07:44:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T07:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [33.8308806178571, -7.10037751785714],
				date: '2022-11-03T07:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 70.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.14,
						Unit: 'F',
					},
				],
			},
			{
				point: [33.8308806178571, -7.10037751785714],
				date: '2022-11-03T07:52:51.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 73.8,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 11.33,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T08:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T08:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4342404098361, -9.642593],
				date: '2022-11-03T08:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.4,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T08:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.4339185802469, -9.6368142962963],
				date: '2022-11-03T08:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.41,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335586272727, -9.6364809],
				date: '2022-11-03T08:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.91,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T08:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.954255, 4.240674],
				date: '2022-11-03T08:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T08:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4342404098361, -9.642593],
				date: '2022-11-03T08:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.43,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4342404098361, -9.642593],
				date: '2022-11-03T08:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 92,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.56,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4334528030303, -9.63627857575758],
				date: '2022-11-03T08:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.18,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T08:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T08:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.1,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339185802469, -9.6368142962963],
				date: '2022-11-03T08:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.41,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335586272727, -9.6364809],
				date: '2022-11-03T09:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T09:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T09:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T09:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334528030303, -9.63627857575758],
				date: '2022-11-03T09:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T09:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T09:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.26,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339185802469, -9.6368142962963],
				date: '2022-11-03T09:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.2,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4339185802469, -9.6368142962963],
				date: '2022-11-03T09:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.11,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4335586272727, -9.6364809],
				date: '2022-11-03T09:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.84,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T09:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.954255, 4.240674],
				date: '2022-11-03T09:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4335586272727, -9.6364809],
				date: '2022-11-03T09:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.17,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T09:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4349114150943, -9.64440537735849],
				date: '2022-11-03T09:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.43,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334528030303, -9.63627857575758],
				date: '2022-11-03T09:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.03,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334528030303, -9.63627857575758],
				date: '2022-11-03T09:44:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.67,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T09:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T09:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.1,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T10:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [51.954255, 4.240674],
				date: '2022-11-03T10:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T10:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.5,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T10:04:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.67,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4349114150943, -9.64440537735849],
				date: '2022-11-03T10:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 82.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.31,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T10:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T10:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4338630394737, -9.63673182894737],
				date: '2022-11-03T10:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4338021348315, -9.63681646067416],
				date: '2022-11-03T10:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T10:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.4349114150943, -9.64440537735849],
				date: '2022-11-03T10:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4349114150943, -9.64440537735849],
				date: '2022-11-03T10:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 92,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.9,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4336251029412, -9.63649625],
				date: '2022-11-03T10:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T10:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T10:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.85,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4338630394737, -9.63673182894737],
				date: '2022-11-03T10:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4338021348315, -9.63681646067416],
				date: '2022-11-03T11:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T11:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T11:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336251029412, -9.63649625],
				date: '2022-11-03T11:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T11:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4338630394737, -9.63673182894737],
				date: '2022-11-03T11:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.35,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4338630394737, -9.63673182894737],
				date: '2022-11-03T11:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4338021348315, -9.63681646067416],
				date: '2022-11-03T11:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T11:30:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 86.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.03,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4338021348315, -9.63681646067416],
				date: '2022-11-03T11:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.952955, 4.232112],
				date: '2022-11-03T11:30:59.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T11:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4328541724138, -9.63979547126437],
				date: '2022-11-03T11:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.94,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336251029412, -9.63649625],
				date: '2022-11-03T11:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336251029412, -9.63649625],
				date: '2022-11-03T11:44:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.83,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T11:45:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T11:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.5,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.883972, -5.473394],
				date: '2022-11-03T11:52:51.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 70.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 12.17,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T12:00:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 86,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.06,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.954255, 4.240674],
				date: '2022-11-03T12:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T12:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T12:03:22.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.61,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4328541724138, -9.63979547126437],
				date: '2022-11-03T12:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.91,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4332148, -9.63619068571428],
				date: '2022-11-03T12:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 67.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.55,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T12:15:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.03,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335544946237, -9.63634035483871],
				date: '2022-11-03T12:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.38,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4369392481752, -9.63524077372263],
				date: '2022-11-03T12:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T12:30:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.9,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.954255, 4.240674],
				date: '2022-11-03T12:30:39.000Z',
				sensors: [],
			},
			{
				point: [30.4328541724138, -9.63979547126437],
				date: '2022-11-03T12:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.88,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4328541724138, -9.63979547126437],
				date: '2022-11-03T12:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 92,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.4,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.06,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4333946666667, -9.64371866666667],
				date: '2022-11-03T12:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.97,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4332148, -9.63619068571428],
				date: '2022-11-03T12:44:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 68.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.58,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T12:45:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.06,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.8844292424242, -5.49402397402597],
				date: '2022-11-03T12:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.98,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335544946237, -9.63634035483871],
				date: '2022-11-03T12:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.23,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4369392481752, -9.63524077372263],
				date: '2022-11-03T13:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T13:00:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.8,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.954255, 4.240674],
				date: '2022-11-03T13:00:39.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T13:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.57,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4333946666667, -9.64371866666667],
				date: '2022-11-03T13:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.97,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4332148, -9.63619068571428],
				date: '2022-11-03T13:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 69.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.58,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4332148, -9.63619068571428],
				date: '2022-11-03T13:15:12.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 7.78,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T13:15:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.06,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.8844292424242, -5.49402397402597],
				date: '2022-11-03T13:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.04,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335544946237, -9.63634035483871],
				date: '2022-11-03T13:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.17,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4335544946237, -9.63634035483871],
				date: '2022-11-03T13:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.17,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4369392481752, -9.63524077372263],
				date: '2022-11-03T13:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.66,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T13:30:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.9,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4369392481752, -9.63524077372263],
				date: '2022-11-03T13:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.44,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T13:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4330865164835, -9.63967716483516],
				date: '2022-11-03T13:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4333946666667, -9.64371866666667],
				date: '2022-11-03T13:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T13:45:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 85.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4333946666667, -9.64371866666667],
				date: '2022-11-03T13:45:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 4.83,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [35.8844292424242, -5.49402397402597],
				date: '2022-11-03T13:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.04,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.8844292424242, -5.49402397402597],
				date: '2022-11-03T13:52:51.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 10.56,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T14:00:31.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 86,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T14:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.66,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T14:02:35.000Z',
				sensors: [
					{
						Name: 'Humidity',
						Value: 86.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 14.06,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T14:03:22.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.61,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4330865164835, -9.63967716483516],
				date: '2022-11-03T14:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433583125, -9.63635879545454],
				date: '2022-11-03T14:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334720521739, -9.63631486086956],
				date: '2022-11-03T14:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T14:30:59.000Z',
				sensors: [],
			},
			{
				point: [30.4330865164835, -9.63967716483516],
				date: '2022-11-03T14:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4330865164835, -9.63967716483516],
				date: '2022-11-03T14:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.4,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4325411428571, -9.64069549350649],
				date: '2022-11-03T14:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T14:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 75.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.3,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433583125, -9.63635879545454],
				date: '2022-11-03T14:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334720521739, -9.63631486086956],
				date: '2022-11-03T15:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T15:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4325411428571, -9.64069549350649],
				date: '2022-11-03T15:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T15:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.86,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433583125, -9.63635879545454],
				date: '2022-11-03T15:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.35,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433583125, -9.63635879545454],
				date: '2022-11-03T15:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4334720521739, -9.63631486086956],
				date: '2022-11-03T15:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334720521739, -9.63631486086956],
				date: '2022-11-03T15:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.1,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T15:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4331279350649, -9.64034220779221],
				date: '2022-11-03T15:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4325411428571, -9.64069549350649],
				date: '2022-11-03T15:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4325411428571, -9.64069549350649],
				date: '2022-11-03T15:45:01.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 92,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T15:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 90.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -12.26,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T15:52:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 9.44,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T16:00:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.12,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T16:00:59.000Z',
				sensors: [],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T16:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.6,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T16:03:22.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.61,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4331279350649, -9.64034220779221],
				date: '2022-11-03T16:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T16:15:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 81,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336610506329, -9.63659812658228],
				date: '2022-11-03T16:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433855245283, -9.63681716981132],
				date: '2022-11-03T16:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.69,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T16:30:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.7,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.16,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4331279350649, -9.64034220779221],
				date: '2022-11-03T16:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4331279350649, -9.64034220779221],
				date: '2022-11-03T16:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.433902942029, -9.64062105797101],
				date: '2022-11-03T16:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.91,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T16:45:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T16:48:46.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 82,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 13.83,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T16:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.29,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336610506329, -9.63659812658228],
				date: '2022-11-03T16:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.26,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433855245283, -9.63681716981132],
				date: '2022-11-03T17:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.66,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4282446, -9.6367858],
				date: '2022-11-03T17:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.54,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433902942029, -9.64062105797101],
				date: '2022-11-03T17:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.97,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T17:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -11.05,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336610506329, -9.63659812658228],
				date: '2022-11-03T17:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.32,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4336610506329, -9.63659812658228],
				date: '2022-11-03T17:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.17,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.433855245283, -9.63681716981132],
				date: '2022-11-03T17:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433855245283, -9.63681716981132],
				date: '2022-11-03T17:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.44,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4282446, -9.6367858],
				date: '2022-11-03T17:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334705810811, -9.64066121621622],
				date: '2022-11-03T17:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433902942029, -9.64062105797101],
				date: '2022-11-03T17:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.97,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433902942029, -9.64062105797101],
				date: '2022-11-03T17:45:01.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 86.1,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T17:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 74.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.89,
						Unit: 'F',
					},
				],
			},
			{
				point: [35.870845, -5.520491],
				date: '2022-11-03T17:52:31.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.3,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 11.06,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4282446, -9.6367858],
				date: '2022-11-03T18:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.66,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4282446, -9.6367858],
				date: '2022-11-03T18:03:22.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4334705810811, -9.64066121621622],
				date: '2022-11-03T18:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4343815283019, -9.63686075471698],
				date: '2022-11-03T18:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.73,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4331905348837, -9.63595588372093],
				date: '2022-11-03T18:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.38,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.43358004, -9.63650266],
				date: '2022-11-03T18:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [51.951598, 4.237888],
				date: '2022-11-03T18:30:59.000Z',
				sensors: [],
			},
			{
				point: [30.4334705810811, -9.64066121621622],
				date: '2022-11-03T18:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4334705810811, -9.64066121621622],
				date: '2022-11-03T18:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.39,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4340352345679, -9.64201290123457],
				date: '2022-11-03T18:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4343815283019, -9.63686075471698],
				date: '2022-11-03T18:44:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 70.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.49,
						Unit: 'F',
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T18:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 72.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.74,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4331905348837, -9.63595588372093],
				date: '2022-11-03T18:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.41,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.43358004, -9.63650266],
				date: '2022-11-03T19:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T19:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4340352345679, -9.64201290123457],
				date: '2022-11-03T19:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.03,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4343815283019, -9.63686075471698],
				date: '2022-11-03T19:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.64,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4343815283019, -9.63686075471698],
				date: '2022-11-03T19:15:12.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.9,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 7.39,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T19:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 72.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.65,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4331905348837, -9.63595588372093],
				date: '2022-11-03T19:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.44,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4331905348837, -9.63595588372093],
				date: '2022-11-03T19:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.1,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.17,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.43358004, -9.63650266],
				date: '2022-11-03T19:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.43358004, -9.63650266],
				date: '2022-11-03T19:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.39,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T19:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4286600888889, -9.63804202222222],
				date: '2022-11-03T19:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4340352345679, -9.64201290123457],
				date: '2022-11-03T19:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.94,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4340352345679, -9.64201290123457],
				date: '2022-11-03T19:45:01.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.6,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.06,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T19:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 71.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.49,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T20:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.54,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T20:03:22.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.61,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4286600888889, -9.63804202222222],
				date: '2022-11-03T20:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4303234576271, -9.63255413559322],
				date: '2022-11-03T20:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.77,
						Unit: 'F',
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T20:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 70.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.37,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4340390875, -9.6368595],
				date: '2022-11-03T20:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 83.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.29,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433044875, -9.63448934166667],
				date: '2022-11-03T20:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4286600888889, -9.63804202222222],
				date: '2022-11-03T20:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.82,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4286600888889, -9.63804202222222],
				date: '2022-11-03T20:41:41.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.39,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4345469885057, -9.64242155172414],
				date: '2022-11-03T20:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4303234576271, -9.63255413559322],
				date: '2022-11-03T20:44:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.77,
						Unit: 'F',
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T20:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 72,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.34,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4340390875, -9.6368595],
				date: '2022-11-03T20:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.1,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.38,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433044875, -9.63448934166667],
				date: '2022-11-03T21:00:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 78.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.84,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T21:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345469885057, -9.64242155172414],
				date: '2022-11-03T21:13:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.2,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.03,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4303234576271, -9.63255413559322],
				date: '2022-11-03T21:14:44.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.8,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -13.79,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4303234576271, -9.63255413559322],
				date: '2022-11-03T21:15:12.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 66.4,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 7.28,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T21:22:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 70.3,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.34,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4340390875, -9.6368595],
				date: '2022-11-03T21:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.57,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4340390875, -9.6368595],
				date: '2022-11-03T21:28:08.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81.2,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 6.06,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.433044875, -9.63448934166667],
				date: '2022-11-03T21:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 95,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.84,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.433044875, -9.63448934166667],
				date: '2022-11-03T21:30:48.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.56,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T21:32:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T21:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 81,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.72,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345469885057, -9.64242155172414],
				date: '2022-11-03T21:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.4,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.06,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4345469885057, -9.64242155172414],
				date: '2022-11-03T21:45:01.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 84.7,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.22,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T21:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 70.5,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.34,
						Unit: 'F',
					},
				],
			},
			{
				point: [36.09004964, -5.42138086666667],
				date: '2022-11-03T21:53:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 73.4,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 12.61,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T22:02:13.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 89,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T22:03:22.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 88,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77.1,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.72,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T22:10:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.76,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4337193647059, -9.63657684705882],
				date: '2022-11-03T22:27:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 76.9,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4370838446602, -9.63507923300971],
				date: '2022-11-03T22:30:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 79,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.84,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T22:40:32.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.7,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.78,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.427211, -9.640919],
				date: '2022-11-03T22:41:20.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 80.5,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: 5.33,
						Setpoint: null,
						Unit: null,
					},
					{
						Name: 'Light',
						Value: 0,
						Setpoint: null,
						Unit: null,
					},
				],
			},
			{
				point: [30.4352922903226, -9.63824432258065],
				date: '2022-11-03T22:43:52.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 93,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 85.5,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -15.09,
						Unit: 'F',
					},
				],
			},
			{
				point: [36.122385, -5.440164],
				date: '2022-11-03T22:52:23.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 70.6,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -10.34,
						Unit: 'F',
					},
				],
			},
			{
				point: [30.4337193647059, -9.63657684705882],
				date: '2022-11-03T22:57:40.000Z',
				sensors: [
					{
						Name: 'Battery',
						Value: 94,
						Unit: null,
					},
					{
						Name: 'Humidity',
						Value: 77,
						Unit: null,
					},
					{
						Name: 'SupplyTemperature',
						Value: -14.63,
						Unit: 'F',
					},
				],
			},
		],
	},
	sensors: [
		{
			name: 'Battery',
			min: 81,
			max: 95,
			data: {
				dates: [
					'2022-11-02T23:00:20.000Z',
					'2022-11-02T23:00:31.000Z',
					'2022-11-02T23:02:13.000Z',
					'2022-11-02T23:13:52.000Z',
					'2022-11-02T23:14:44.000Z',
					'2022-11-02T23:15:12.000Z',
					'2022-11-02T23:15:31.000Z',
					'2022-11-02T23:22:23.000Z',
					'2022-11-02T23:27:40.000Z',
					'2022-11-02T23:28:08.000Z',
					'2022-11-02T23:30:20.000Z',
					'2022-11-02T23:30:31.000Z',
					'2022-11-02T23:30:48.000Z',
					'2022-11-02T23:32:13.000Z',
					'2022-11-02T23:40:32.000Z',
					'2022-11-02T23:43:52.000Z',
					'2022-11-02T23:44:20.000Z',
					'2022-11-02T23:45:31.000Z',
					'2022-11-02T23:52:23.000Z',
					'2022-11-02T23:52:51.000Z',
					'2022-11-03T00:00:31.000Z',
					'2022-11-03T00:02:13.000Z',
					'2022-11-03T00:04:23.000Z',
					'2022-11-03T00:10:32.000Z',
					'2022-11-03T00:15:31.000Z',
					'2022-11-03T00:27:40.000Z',
					'2022-11-03T00:30:20.000Z',
					'2022-11-03T00:30:31.000Z',
					'2022-11-03T00:40:32.000Z',
					'2022-11-03T00:41:41.000Z',
					'2022-11-03T00:43:52.000Z',
					'2022-11-03T00:45:31.000Z',
					'2022-11-03T00:52:23.000Z',
					'2022-11-03T00:57:40.000Z',
					'2022-11-03T01:00:20.000Z',
					'2022-11-03T01:00:31.000Z',
					'2022-11-03T01:02:13.000Z',
					'2022-11-03T01:13:52.000Z',
					'2022-11-03T01:15:31.000Z',
					'2022-11-03T01:22:23.000Z',
					'2022-11-03T01:27:40.000Z',
					'2022-11-03T01:28:08.000Z',
					'2022-11-03T01:30:20.000Z',
					'2022-11-03T01:30:31.000Z',
					'2022-11-03T01:30:48.000Z',
					'2022-11-03T01:32:13.000Z',
					'2022-11-03T01:40:32.000Z',
					'2022-11-03T01:43:52.000Z',
					'2022-11-03T01:44:20.000Z',
					'2022-11-03T01:45:31.000Z',
					'2022-11-03T01:52:23.000Z',
					'2022-11-03T01:52:51.000Z',
					'2022-11-03T02:00:31.000Z',
					'2022-11-03T02:02:13.000Z',
					'2022-11-03T02:02:21.000Z',
					'2022-11-03T02:10:32.000Z',
					'2022-11-03T02:15:31.000Z',
					'2022-11-03T02:27:40.000Z',
					'2022-11-03T02:30:20.000Z',
					'2022-11-03T02:30:31.000Z',
					'2022-11-03T02:40:32.000Z',
					'2022-11-03T02:41:41.000Z',
					'2022-11-03T02:43:52.000Z',
					'2022-11-03T02:45:31.000Z',
					'2022-11-03T02:52:23.000Z',
					'2022-11-03T02:57:40.000Z',
					'2022-11-03T03:00:20.000Z',
					'2022-11-03T03:00:31.000Z',
					'2022-11-03T03:02:13.000Z',
					'2022-11-03T03:13:52.000Z',
					'2022-11-03T03:15:31.000Z',
					'2022-11-03T03:22:23.000Z',
					'2022-11-03T03:27:40.000Z',
					'2022-11-03T03:28:08.000Z',
					'2022-11-03T03:30:20.000Z',
					'2022-11-03T03:30:31.000Z',
					'2022-11-03T03:30:48.000Z',
					'2022-11-03T03:32:13.000Z',
					'2022-11-03T03:43:52.000Z',
					'2022-11-03T03:44:20.000Z',
					'2022-11-03T03:45:31.000Z',
					'2022-11-03T03:52:23.000Z',
					'2022-11-03T03:52:51.000Z',
					'2022-11-03T04:00:31.000Z',
					'2022-11-03T04:02:13.000Z',
					'2022-11-03T04:04:23.000Z',
					'2022-11-03T04:27:40.000Z',
					'2022-11-03T04:30:20.000Z',
					'2022-11-03T04:30:31.000Z',
					'2022-11-03T04:43:52.000Z',
					'2022-11-03T04:45:31.000Z',
					'2022-11-03T04:52:23.000Z',
					'2022-11-03T04:57:40.000Z',
					'2022-11-03T05:00:20.000Z',
					'2022-11-03T05:00:31.000Z',
					'2022-11-03T05:02:13.000Z',
					'2022-11-03T05:13:52.000Z',
					'2022-11-03T05:15:31.000Z',
					'2022-11-03T05:22:23.000Z',
					'2022-11-03T05:27:40.000Z',
					'2022-11-03T05:28:08.000Z',
					'2022-11-03T05:30:20.000Z',
					'2022-11-03T05:30:31.000Z',
					'2022-11-03T05:30:48.000Z',
					'2022-11-03T05:32:13.000Z',
					'2022-11-03T05:40:32.000Z',
					'2022-11-03T05:43:52.000Z',
					'2022-11-03T05:44:20.000Z',
					'2022-11-03T05:45:31.000Z',
					'2022-11-03T05:52:23.000Z',
					'2022-11-03T05:52:51.000Z',
					'2022-11-03T06:00:31.000Z',
					'2022-11-03T06:02:13.000Z',
					'2022-11-03T06:04:23.000Z',
					'2022-11-03T06:10:32.000Z',
					'2022-11-03T06:14:44.000Z',
					'2022-11-03T06:15:31.000Z',
					'2022-11-03T06:27:40.000Z',
					'2022-11-03T06:30:20.000Z',
					'2022-11-03T06:30:31.000Z',
					'2022-11-03T06:40:32.000Z',
					'2022-11-03T06:41:41.000Z',
					'2022-11-03T06:43:52.000Z',
					'2022-11-03T06:44:44.000Z',
					'2022-11-03T06:45:31.000Z',
					'2022-11-03T06:52:23.000Z',
					'2022-11-03T06:57:40.000Z',
					'2022-11-03T07:00:20.000Z',
					'2022-11-03T07:00:31.000Z',
					'2022-11-03T07:02:13.000Z',
					'2022-11-03T07:13:52.000Z',
					'2022-11-03T07:14:44.000Z',
					'2022-11-03T07:15:12.000Z',
					'2022-11-03T07:15:31.000Z',
					'2022-11-03T07:22:23.000Z',
					'2022-11-03T07:27:40.000Z',
					'2022-11-03T07:28:08.000Z',
					'2022-11-03T07:30:20.000Z',
					'2022-11-03T07:30:31.000Z',
					'2022-11-03T07:30:48.000Z',
					'2022-11-03T07:32:13.000Z',
					'2022-11-03T07:40:32.000Z',
					'2022-11-03T07:43:52.000Z',
					'2022-11-03T07:44:20.000Z',
					'2022-11-03T07:45:31.000Z',
					'2022-11-03T07:52:23.000Z',
					'2022-11-03T07:52:51.000Z',
					'2022-11-03T08:00:31.000Z',
					'2022-11-03T08:02:13.000Z',
					'2022-11-03T08:10:32.000Z',
					'2022-11-03T08:15:31.000Z',
					'2022-11-03T08:27:40.000Z',
					'2022-11-03T08:30:20.000Z',
					'2022-11-03T08:30:31.000Z',
					'2022-11-03T08:32:13.000Z',
					'2022-11-03T08:40:32.000Z',
					'2022-11-03T08:41:41.000Z',
					'2022-11-03T08:43:52.000Z',
					'2022-11-03T08:45:31.000Z',
					'2022-11-03T08:52:23.000Z',
					'2022-11-03T08:57:40.000Z',
					'2022-11-03T09:00:20.000Z',
					'2022-11-03T09:00:31.000Z',
					'2022-11-03T09:02:13.000Z',
					'2022-11-03T09:13:52.000Z',
					'2022-11-03T09:15:31.000Z',
					'2022-11-03T09:22:23.000Z',
					'2022-11-03T09:27:40.000Z',
					'2022-11-03T09:28:08.000Z',
					'2022-11-03T09:30:20.000Z',
					'2022-11-03T09:30:31.000Z',
					'2022-11-03T09:30:48.000Z',
					'2022-11-03T09:32:13.000Z',
					'2022-11-03T09:40:32.000Z',
					'2022-11-03T09:43:52.000Z',
					'2022-11-03T09:44:20.000Z',
					'2022-11-03T09:45:31.000Z',
					'2022-11-03T09:52:23.000Z',
					'2022-11-03T10:00:31.000Z',
					'2022-11-03T10:02:13.000Z',
					'2022-11-03T10:04:23.000Z',
					'2022-11-03T10:10:32.000Z',
					'2022-11-03T10:15:31.000Z',
					'2022-11-03T10:22:23.000Z',
					'2022-11-03T10:27:40.000Z',
					'2022-11-03T10:30:20.000Z',
					'2022-11-03T10:30:31.000Z',
					'2022-11-03T10:40:32.000Z',
					'2022-11-03T10:41:41.000Z',
					'2022-11-03T10:43:52.000Z',
					'2022-11-03T10:45:31.000Z',
					'2022-11-03T10:52:23.000Z',
					'2022-11-03T10:57:40.000Z',
					'2022-11-03T11:00:20.000Z',
					'2022-11-03T11:00:31.000Z',
					'2022-11-03T11:02:13.000Z',
					'2022-11-03T11:13:52.000Z',
					'2022-11-03T11:22:23.000Z',
					'2022-11-03T11:27:40.000Z',
					'2022-11-03T11:28:08.000Z',
					'2022-11-03T11:30:20.000Z',
					'2022-11-03T11:30:48.000Z',
					'2022-11-03T11:32:13.000Z',
					'2022-11-03T11:40:32.000Z',
					'2022-11-03T11:43:52.000Z',
					'2022-11-03T11:44:20.000Z',
					'2022-11-03T11:52:23.000Z',
					'2022-11-03T11:52:51.000Z',
					'2022-11-03T12:02:13.000Z',
					'2022-11-03T12:03:22.000Z',
					'2022-11-03T12:10:32.000Z',
					'2022-11-03T12:14:44.000Z',
					'2022-11-03T12:27:40.000Z',
					'2022-11-03T12:30:20.000Z',
					'2022-11-03T12:40:32.000Z',
					'2022-11-03T12:41:41.000Z',
					'2022-11-03T12:43:52.000Z',
					'2022-11-03T12:44:44.000Z',
					'2022-11-03T12:52:23.000Z',
					'2022-11-03T12:57:40.000Z',
					'2022-11-03T13:00:20.000Z',
					'2022-11-03T13:02:13.000Z',
					'2022-11-03T13:13:52.000Z',
					'2022-11-03T13:14:44.000Z',
					'2022-11-03T13:15:12.000Z',
					'2022-11-03T13:22:23.000Z',
					'2022-11-03T13:27:40.000Z',
					'2022-11-03T13:28:08.000Z',
					'2022-11-03T13:30:20.000Z',
					'2022-11-03T13:30:48.000Z',
					'2022-11-03T13:32:13.000Z',
					'2022-11-03T13:40:32.000Z',
					'2022-11-03T13:43:52.000Z',
					'2022-11-03T13:45:44.000Z',
					'2022-11-03T13:52:23.000Z',
					'2022-11-03T13:52:51.000Z',
					'2022-11-03T14:02:13.000Z',
					'2022-11-03T14:03:22.000Z',
					'2022-11-03T14:10:32.000Z',
					'2022-11-03T14:27:40.000Z',
					'2022-11-03T14:30:20.000Z',
					'2022-11-03T14:40:32.000Z',
					'2022-11-03T14:41:41.000Z',
					'2022-11-03T14:43:52.000Z',
					'2022-11-03T14:52:23.000Z',
					'2022-11-03T14:57:40.000Z',
					'2022-11-03T15:00:20.000Z',
					'2022-11-03T15:02:13.000Z',
					'2022-11-03T15:13:52.000Z',
					'2022-11-03T15:22:23.000Z',
					'2022-11-03T15:27:40.000Z',
					'2022-11-03T15:28:08.000Z',
					'2022-11-03T15:30:20.000Z',
					'2022-11-03T15:30:48.000Z',
					'2022-11-03T15:32:13.000Z',
					'2022-11-03T15:40:32.000Z',
					'2022-11-03T15:43:52.000Z',
					'2022-11-03T15:45:01.000Z',
					'2022-11-03T15:52:23.000Z',
					'2022-11-03T15:52:31.000Z',
					'2022-11-03T16:00:31.000Z',
					'2022-11-03T16:02:13.000Z',
					'2022-11-03T16:03:22.000Z',
					'2022-11-03T16:10:32.000Z',
					'2022-11-03T16:15:31.000Z',
					'2022-11-03T16:27:40.000Z',
					'2022-11-03T16:30:20.000Z',
					'2022-11-03T16:30:31.000Z',
					'2022-11-03T16:40:32.000Z',
					'2022-11-03T16:41:41.000Z',
					'2022-11-03T16:43:52.000Z',
					'2022-11-03T16:45:31.000Z',
					'2022-11-03T16:48:46.000Z',
					'2022-11-03T16:52:23.000Z',
					'2022-11-03T16:57:40.000Z',
					'2022-11-03T17:00:20.000Z',
					'2022-11-03T17:02:13.000Z',
					'2022-11-03T17:13:52.000Z',
					'2022-11-03T17:22:23.000Z',
					'2022-11-03T17:27:40.000Z',
					'2022-11-03T17:28:08.000Z',
					'2022-11-03T17:30:20.000Z',
					'2022-11-03T17:30:48.000Z',
					'2022-11-03T17:32:13.000Z',
					'2022-11-03T17:40:32.000Z',
					'2022-11-03T17:43:52.000Z',
					'2022-11-03T17:45:01.000Z',
					'2022-11-03T17:52:23.000Z',
					'2022-11-03T17:52:31.000Z',
					'2022-11-03T18:02:13.000Z',
					'2022-11-03T18:03:22.000Z',
					'2022-11-03T18:10:32.000Z',
					'2022-11-03T18:14:44.000Z',
					'2022-11-03T18:27:40.000Z',
					'2022-11-03T18:30:20.000Z',
					'2022-11-03T18:40:32.000Z',
					'2022-11-03T18:41:41.000Z',
					'2022-11-03T18:43:52.000Z',
					'2022-11-03T18:44:44.000Z',
					'2022-11-03T18:52:23.000Z',
					'2022-11-03T18:57:40.000Z',
					'2022-11-03T19:00:20.000Z',
					'2022-11-03T19:02:13.000Z',
					'2022-11-03T19:13:52.000Z',
					'2022-11-03T19:14:44.000Z',
					'2022-11-03T19:15:12.000Z',
					'2022-11-03T19:22:23.000Z',
					'2022-11-03T19:27:40.000Z',
					'2022-11-03T19:28:08.000Z',
					'2022-11-03T19:30:20.000Z',
					'2022-11-03T19:30:48.000Z',
					'2022-11-03T19:32:13.000Z',
					'2022-11-03T19:40:32.000Z',
					'2022-11-03T19:43:52.000Z',
					'2022-11-03T19:45:01.000Z',
					'2022-11-03T19:52:23.000Z',
					'2022-11-03T20:02:13.000Z',
					'2022-11-03T20:03:22.000Z',
					'2022-11-03T20:10:32.000Z',
					'2022-11-03T20:14:44.000Z',
					'2022-11-03T20:22:23.000Z',
					'2022-11-03T20:27:40.000Z',
					'2022-11-03T20:30:20.000Z',
					'2022-11-03T20:40:32.000Z',
					'2022-11-03T20:41:41.000Z',
					'2022-11-03T20:43:52.000Z',
					'2022-11-03T20:44:44.000Z',
					'2022-11-03T20:52:23.000Z',
					'2022-11-03T20:57:40.000Z',
					'2022-11-03T21:00:20.000Z',
					'2022-11-03T21:02:13.000Z',
					'2022-11-03T21:13:52.000Z',
					'2022-11-03T21:14:44.000Z',
					'2022-11-03T21:15:12.000Z',
					'2022-11-03T21:22:23.000Z',
					'2022-11-03T21:27:40.000Z',
					'2022-11-03T21:28:08.000Z',
					'2022-11-03T21:30:20.000Z',
					'2022-11-03T21:30:48.000Z',
					'2022-11-03T21:32:13.000Z',
					'2022-11-03T21:40:32.000Z',
					'2022-11-03T21:43:52.000Z',
					'2022-11-03T21:45:01.000Z',
					'2022-11-03T21:52:23.000Z',
					'2022-11-03T21:53:32.000Z',
					'2022-11-03T22:02:13.000Z',
					'2022-11-03T22:03:22.000Z',
					'2022-11-03T22:10:32.000Z',
					'2022-11-03T22:27:40.000Z',
					'2022-11-03T22:30:20.000Z',
					'2022-11-03T22:40:32.000Z',
					'2022-11-03T22:41:20.000Z',
					'2022-11-03T22:43:52.000Z',
					'2022-11-03T22:52:23.000Z',
					'2022-11-03T22:57:40.000Z',
				],
				values: [
					94, 82, 91, 94, 95, 94, 82, 94, 95, 94, 95, 82, 94, 91, 93, 94, 93,
					82, 94, 93, 82, 91, 90, 93, 82, 94, 94, 82, 94, 92, 94, 82, 93, 95,
					94, 82, 90, 94, 82, 94, 95, 94, 95, 82, 94, 90, 93, 94, 93, 82, 94,
					93, 82, 90, 89, 93, 82, 94, 94, 82, 94, 92, 94, 82, 93, 95, 95, 82,
					90, 94, 82, 94, 95, 94, 95, 82, 94, 90, 94, 93, 82, 94, 93, 82, 90,
					90, 94, 94, 82, 94, 82, 93, 95, 95, 82, 89, 94, 82, 94, 95, 94, 95,
					82, 94, 90, 93, 94, 93, 82, 94, 93, 82, 90, 89, 93, 94, 82, 94, 94,
					82, 93, 92, 94, 94, 82, 94, 95, 94, 82, 89, 94, 95, 94, 82, 94, 95,
					94, 95, 82, 94, 89, 93, 94, 93, 82, 94, 93, 82, 89, 93, 82, 94, 94,
					82, 88, 94, 92, 94, 82, 94, 95, 94, 82, 89, 94, 82, 94, 95, 94, 95,
					82, 94, 89, 93, 94, 93, 82, 94, 82, 89, 88, 93, 82, 93, 94, 94, 82,
					94, 92, 94, 82, 93, 95, 95, 82, 88, 94, 94, 95, 94, 95, 94, 89, 93,
					94, 93, 94, 94, 89, 88, 93, 94, 94, 94, 94, 92, 94, 94, 94, 94, 94,
					89, 94, 95, 94, 94, 95, 94, 95, 94, 89, 93, 94, 93, 94, 93, 89, 88,
					94, 94, 94, 94, 93, 93, 94, 95, 95, 89, 93, 94, 95, 94, 95, 94, 89,
					93, 94, 92, 94, 93, 82, 89, 88, 94, 81, 94, 94, 82, 94, 93, 93, 82,
					82, 94, 95, 95, 89, 94, 94, 95, 94, 95, 94, 89, 93, 94, 93, 94, 94,
					89, 88, 94, 94, 94, 94, 94, 93, 93, 95, 94, 94, 95, 89, 94, 95, 94,
					94, 95, 94, 95, 94, 89, 93, 94, 93, 95, 89, 88, 94, 94, 93, 94, 94,
					94, 93, 93, 95, 94, 94, 95, 89, 94, 95, 94, 94, 95, 94, 95, 94, 89,
					93, 94, 93, 94, 94, 89, 88, 94, 94, 94, 94, 93, 93, 94, 94,
				],
			},
			unit: null,
			avg: 91.49295774647888,
		},
		{
			name: 'Humidity',
			min: 65.4,
			max: 90.2,
			data: {
				dates: [
					'2022-11-02T23:00:20.000Z',
					'2022-11-02T23:02:13.000Z',
					'2022-11-02T23:13:52.000Z',
					'2022-11-02T23:14:44.000Z',
					'2022-11-02T23:15:12.000Z',
					'2022-11-02T23:22:23.000Z',
					'2022-11-02T23:27:40.000Z',
					'2022-11-02T23:28:08.000Z',
					'2022-11-02T23:30:20.000Z',
					'2022-11-02T23:30:48.000Z',
					'2022-11-02T23:32:13.000Z',
					'2022-11-02T23:40:32.000Z',
					'2022-11-02T23:43:52.000Z',
					'2022-11-02T23:44:20.000Z',
					'2022-11-02T23:52:23.000Z',
					'2022-11-02T23:52:51.000Z',
					'2022-11-03T00:02:13.000Z',
					'2022-11-03T00:04:23.000Z',
					'2022-11-03T00:10:32.000Z',
					'2022-11-03T00:27:40.000Z',
					'2022-11-03T00:30:20.000Z',
					'2022-11-03T00:40:32.000Z',
					'2022-11-03T00:41:41.000Z',
					'2022-11-03T00:43:52.000Z',
					'2022-11-03T00:52:23.000Z',
					'2022-11-03T00:57:40.000Z',
					'2022-11-03T01:00:20.000Z',
					'2022-11-03T01:02:13.000Z',
					'2022-11-03T01:13:52.000Z',
					'2022-11-03T01:22:23.000Z',
					'2022-11-03T01:27:40.000Z',
					'2022-11-03T01:28:08.000Z',
					'2022-11-03T01:30:20.000Z',
					'2022-11-03T01:30:48.000Z',
					'2022-11-03T01:32:13.000Z',
					'2022-11-03T01:40:32.000Z',
					'2022-11-03T01:43:52.000Z',
					'2022-11-03T01:44:20.000Z',
					'2022-11-03T01:52:23.000Z',
					'2022-11-03T01:52:51.000Z',
					'2022-11-03T02:02:13.000Z',
					'2022-11-03T02:02:21.000Z',
					'2022-11-03T02:10:32.000Z',
					'2022-11-03T02:27:40.000Z',
					'2022-11-03T02:30:20.000Z',
					'2022-11-03T02:40:32.000Z',
					'2022-11-03T02:41:41.000Z',
					'2022-11-03T02:43:52.000Z',
					'2022-11-03T02:52:23.000Z',
					'2022-11-03T02:57:40.000Z',
					'2022-11-03T03:00:20.000Z',
					'2022-11-03T03:02:13.000Z',
					'2022-11-03T03:13:52.000Z',
					'2022-11-03T03:22:23.000Z',
					'2022-11-03T03:27:40.000Z',
					'2022-11-03T03:28:08.000Z',
					'2022-11-03T03:30:20.000Z',
					'2022-11-03T03:30:48.000Z',
					'2022-11-03T03:32:13.000Z',
					'2022-11-03T03:43:52.000Z',
					'2022-11-03T03:44:20.000Z',
					'2022-11-03T03:52:23.000Z',
					'2022-11-03T03:52:51.000Z',
					'2022-11-03T04:02:13.000Z',
					'2022-11-03T04:04:23.000Z',
					'2022-11-03T04:27:40.000Z',
					'2022-11-03T04:30:20.000Z',
					'2022-11-03T04:43:52.000Z',
					'2022-11-03T04:52:23.000Z',
					'2022-11-03T04:57:40.000Z',
					'2022-11-03T05:00:20.000Z',
					'2022-11-03T05:02:13.000Z',
					'2022-11-03T05:13:52.000Z',
					'2022-11-03T05:22:23.000Z',
					'2022-11-03T05:27:40.000Z',
					'2022-11-03T05:28:08.000Z',
					'2022-11-03T05:30:20.000Z',
					'2022-11-03T05:30:48.000Z',
					'2022-11-03T05:32:13.000Z',
					'2022-11-03T05:40:32.000Z',
					'2022-11-03T05:43:52.000Z',
					'2022-11-03T05:44:20.000Z',
					'2022-11-03T05:52:23.000Z',
					'2022-11-03T05:52:51.000Z',
					'2022-11-03T06:02:13.000Z',
					'2022-11-03T06:04:23.000Z',
					'2022-11-03T06:10:32.000Z',
					'2022-11-03T06:14:44.000Z',
					'2022-11-03T06:27:40.000Z',
					'2022-11-03T06:30:20.000Z',
					'2022-11-03T06:40:32.000Z',
					'2022-11-03T06:41:41.000Z',
					'2022-11-03T06:43:52.000Z',
					'2022-11-03T06:44:44.000Z',
					'2022-11-03T06:52:23.000Z',
					'2022-11-03T06:57:40.000Z',
					'2022-11-03T07:00:20.000Z',
					'2022-11-03T07:02:13.000Z',
					'2022-11-03T07:13:52.000Z',
					'2022-11-03T07:14:44.000Z',
					'2022-11-03T07:15:12.000Z',
					'2022-11-03T07:22:23.000Z',
					'2022-11-03T07:27:40.000Z',
					'2022-11-03T07:28:08.000Z',
					'2022-11-03T07:30:20.000Z',
					'2022-11-03T07:30:48.000Z',
					'2022-11-03T07:32:13.000Z',
					'2022-11-03T07:40:32.000Z',
					'2022-11-03T07:43:52.000Z',
					'2022-11-03T07:44:20.000Z',
					'2022-11-03T07:52:23.000Z',
					'2022-11-03T07:52:51.000Z',
					'2022-11-03T08:02:13.000Z',
					'2022-11-03T08:10:32.000Z',
					'2022-11-03T08:27:40.000Z',
					'2022-11-03T08:30:20.000Z',
					'2022-11-03T08:32:13.000Z',
					'2022-11-03T08:40:32.000Z',
					'2022-11-03T08:41:41.000Z',
					'2022-11-03T08:43:52.000Z',
					'2022-11-03T08:52:23.000Z',
					'2022-11-03T08:57:40.000Z',
					'2022-11-03T09:00:20.000Z',
					'2022-11-03T09:02:13.000Z',
					'2022-11-03T09:13:52.000Z',
					'2022-11-03T09:22:23.000Z',
					'2022-11-03T09:27:40.000Z',
					'2022-11-03T09:28:08.000Z',
					'2022-11-03T09:30:20.000Z',
					'2022-11-03T09:30:48.000Z',
					'2022-11-03T09:32:13.000Z',
					'2022-11-03T09:40:32.000Z',
					'2022-11-03T09:43:52.000Z',
					'2022-11-03T09:44:20.000Z',
					'2022-11-03T09:52:23.000Z',
					'2022-11-03T10:02:13.000Z',
					'2022-11-03T10:04:23.000Z',
					'2022-11-03T10:10:32.000Z',
					'2022-11-03T10:22:23.000Z',
					'2022-11-03T10:27:40.000Z',
					'2022-11-03T10:30:20.000Z',
					'2022-11-03T10:40:32.000Z',
					'2022-11-03T10:41:41.000Z',
					'2022-11-03T10:43:52.000Z',
					'2022-11-03T10:52:23.000Z',
					'2022-11-03T10:57:40.000Z',
					'2022-11-03T11:00:20.000Z',
					'2022-11-03T11:02:13.000Z',
					'2022-11-03T11:13:52.000Z',
					'2022-11-03T11:22:23.000Z',
					'2022-11-03T11:27:40.000Z',
					'2022-11-03T11:28:08.000Z',
					'2022-11-03T11:30:20.000Z',
					'2022-11-03T11:30:31.000Z',
					'2022-11-03T11:30:48.000Z',
					'2022-11-03T11:32:13.000Z',
					'2022-11-03T11:40:32.000Z',
					'2022-11-03T11:43:52.000Z',
					'2022-11-03T11:44:20.000Z',
					'2022-11-03T11:45:31.000Z',
					'2022-11-03T11:52:23.000Z',
					'2022-11-03T11:52:51.000Z',
					'2022-11-03T12:00:31.000Z',
					'2022-11-03T12:02:13.000Z',
					'2022-11-03T12:03:22.000Z',
					'2022-11-03T12:10:32.000Z',
					'2022-11-03T12:14:44.000Z',
					'2022-11-03T12:15:31.000Z',
					'2022-11-03T12:27:40.000Z',
					'2022-11-03T12:30:20.000Z',
					'2022-11-03T12:30:31.000Z',
					'2022-11-03T12:40:32.000Z',
					'2022-11-03T12:41:41.000Z',
					'2022-11-03T12:43:52.000Z',
					'2022-11-03T12:44:44.000Z',
					'2022-11-03T12:45:31.000Z',
					'2022-11-03T12:52:23.000Z',
					'2022-11-03T12:57:40.000Z',
					'2022-11-03T13:00:20.000Z',
					'2022-11-03T13:00:31.000Z',
					'2022-11-03T13:02:13.000Z',
					'2022-11-03T13:13:52.000Z',
					'2022-11-03T13:14:44.000Z',
					'2022-11-03T13:15:12.000Z',
					'2022-11-03T13:15:31.000Z',
					'2022-11-03T13:22:23.000Z',
					'2022-11-03T13:27:40.000Z',
					'2022-11-03T13:28:08.000Z',
					'2022-11-03T13:30:20.000Z',
					'2022-11-03T13:30:31.000Z',
					'2022-11-03T13:30:48.000Z',
					'2022-11-03T13:32:13.000Z',
					'2022-11-03T13:40:32.000Z',
					'2022-11-03T13:43:52.000Z',
					'2022-11-03T13:45:31.000Z',
					'2022-11-03T13:45:44.000Z',
					'2022-11-03T13:52:23.000Z',
					'2022-11-03T13:52:51.000Z',
					'2022-11-03T14:00:31.000Z',
					'2022-11-03T14:02:13.000Z',
					'2022-11-03T14:02:35.000Z',
					'2022-11-03T14:03:22.000Z',
					'2022-11-03T14:10:32.000Z',
					'2022-11-03T14:27:40.000Z',
					'2022-11-03T14:30:20.000Z',
					'2022-11-03T14:40:32.000Z',
					'2022-11-03T14:41:41.000Z',
					'2022-11-03T14:43:52.000Z',
					'2022-11-03T14:52:23.000Z',
					'2022-11-03T14:57:40.000Z',
					'2022-11-03T15:00:20.000Z',
					'2022-11-03T15:02:13.000Z',
					'2022-11-03T15:13:52.000Z',
					'2022-11-03T15:22:23.000Z',
					'2022-11-03T15:27:40.000Z',
					'2022-11-03T15:28:08.000Z',
					'2022-11-03T15:30:20.000Z',
					'2022-11-03T15:30:48.000Z',
					'2022-11-03T15:32:13.000Z',
					'2022-11-03T15:40:32.000Z',
					'2022-11-03T15:43:52.000Z',
					'2022-11-03T15:45:01.000Z',
					'2022-11-03T15:52:23.000Z',
					'2022-11-03T15:52:31.000Z',
					'2022-11-03T16:00:31.000Z',
					'2022-11-03T16:02:13.000Z',
					'2022-11-03T16:03:22.000Z',
					'2022-11-03T16:10:32.000Z',
					'2022-11-03T16:15:31.000Z',
					'2022-11-03T16:27:40.000Z',
					'2022-11-03T16:30:20.000Z',
					'2022-11-03T16:30:31.000Z',
					'2022-11-03T16:40:32.000Z',
					'2022-11-03T16:41:41.000Z',
					'2022-11-03T16:43:52.000Z',
					'2022-11-03T16:45:31.000Z',
					'2022-11-03T16:48:46.000Z',
					'2022-11-03T16:52:23.000Z',
					'2022-11-03T16:57:40.000Z',
					'2022-11-03T17:00:20.000Z',
					'2022-11-03T17:02:13.000Z',
					'2022-11-03T17:13:52.000Z',
					'2022-11-03T17:22:23.000Z',
					'2022-11-03T17:27:40.000Z',
					'2022-11-03T17:28:08.000Z',
					'2022-11-03T17:30:20.000Z',
					'2022-11-03T17:30:48.000Z',
					'2022-11-03T17:32:13.000Z',
					'2022-11-03T17:40:32.000Z',
					'2022-11-03T17:43:52.000Z',
					'2022-11-03T17:45:01.000Z',
					'2022-11-03T17:52:23.000Z',
					'2022-11-03T17:52:31.000Z',
					'2022-11-03T18:02:13.000Z',
					'2022-11-03T18:03:22.000Z',
					'2022-11-03T18:10:32.000Z',
					'2022-11-03T18:14:44.000Z',
					'2022-11-03T18:27:40.000Z',
					'2022-11-03T18:30:20.000Z',
					'2022-11-03T18:40:32.000Z',
					'2022-11-03T18:41:41.000Z',
					'2022-11-03T18:43:52.000Z',
					'2022-11-03T18:44:44.000Z',
					'2022-11-03T18:52:23.000Z',
					'2022-11-03T18:57:40.000Z',
					'2022-11-03T19:00:20.000Z',
					'2022-11-03T19:02:13.000Z',
					'2022-11-03T19:13:52.000Z',
					'2022-11-03T19:14:44.000Z',
					'2022-11-03T19:15:12.000Z',
					'2022-11-03T19:22:23.000Z',
					'2022-11-03T19:27:40.000Z',
					'2022-11-03T19:28:08.000Z',
					'2022-11-03T19:30:20.000Z',
					'2022-11-03T19:30:48.000Z',
					'2022-11-03T19:32:13.000Z',
					'2022-11-03T19:40:32.000Z',
					'2022-11-03T19:43:52.000Z',
					'2022-11-03T19:45:01.000Z',
					'2022-11-03T19:52:23.000Z',
					'2022-11-03T20:02:13.000Z',
					'2022-11-03T20:03:22.000Z',
					'2022-11-03T20:10:32.000Z',
					'2022-11-03T20:14:44.000Z',
					'2022-11-03T20:22:23.000Z',
					'2022-11-03T20:27:40.000Z',
					'2022-11-03T20:30:20.000Z',
					'2022-11-03T20:40:32.000Z',
					'2022-11-03T20:41:41.000Z',
					'2022-11-03T20:43:52.000Z',
					'2022-11-03T20:44:44.000Z',
					'2022-11-03T20:52:23.000Z',
					'2022-11-03T20:57:40.000Z',
					'2022-11-03T21:00:20.000Z',
					'2022-11-03T21:02:13.000Z',
					'2022-11-03T21:13:52.000Z',
					'2022-11-03T21:14:44.000Z',
					'2022-11-03T21:15:12.000Z',
					'2022-11-03T21:22:23.000Z',
					'2022-11-03T21:27:40.000Z',
					'2022-11-03T21:28:08.000Z',
					'2022-11-03T21:30:20.000Z',
					'2022-11-03T21:30:48.000Z',
					'2022-11-03T21:32:13.000Z',
					'2022-11-03T21:40:32.000Z',
					'2022-11-03T21:43:52.000Z',
					'2022-11-03T21:45:01.000Z',
					'2022-11-03T21:52:23.000Z',
					'2022-11-03T21:53:32.000Z',
					'2022-11-03T22:02:13.000Z',
					'2022-11-03T22:03:22.000Z',
					'2022-11-03T22:10:32.000Z',
					'2022-11-03T22:27:40.000Z',
					'2022-11-03T22:30:20.000Z',
					'2022-11-03T22:40:32.000Z',
					'2022-11-03T22:41:20.000Z',
					'2022-11-03T22:43:52.000Z',
					'2022-11-03T22:52:23.000Z',
					'2022-11-03T22:57:40.000Z',
				],
				values: [
					78.5, 78.4, 81.8, 68.8, 65.4, 74.6, 77.9, 78.7, 78.6, 78.2, 74.2,
					74.7, 80.9, 80.5, 75, 74.6, 74.8, 74.7, 75, 79.5, 78.2, 73.9, 74.1,
					81.5, 75.2, 79.8, 78.4, 75.1, 81.8, 76.9, 80.1, 78.9, 78.4, 77.8,
					75.2, 75.7, 82.1, 81.1, 78, 72.8, 75.4, 74.6, 76.2, 81.8, 78.6, 76.6,
					74.8, 82.7, 76.1, 79.2, 78.4, 75.2, 82.2, 74.5, 80, 80.2, 78.1, 78.4,
					75.7, 82.4, 82.2, 72.8, 75.5, 76.1, 76.7, 80.7, 78.6, 82.9, 85.8,
					80.9, 78.6, 76.2, 83.1, 82.9, 81, 80.3, 78.6, 78.3, 76.4, 78, 83.4,
					82.5, 76.2, 83.6, 79.1, 76, 78.3, 66.9, 80.1, 78.1, 78.5, 77.4, 83.1,
					67, 74.1, 80.8, 78.3, 76.1, 83.4, 67.1, 66.6, 71.4, 81.1, 81.1, 78.8,
					78.7, 76.7, 77.9, 83.7, 83.2, 70.4, 73.8, 76.9, 78.6, 81.4, 79, 76.6,
					79, 78.6, 83.9, 79.2, 81.4, 79.1, 77, 84.5, 80.6, 84.2, 81.3, 78.7,
					78.7, 76.4, 79.1, 83.8, 83.7, 81.8, 76.5, 75.5, 82.6, 81.4, 81, 78.7,
					81.4, 78.9, 83.7, 81.7, 81.1, 78.8, 76.9, 83.9, 81.5, 81.3, 80.7,
					78.8, 86.4, 78.3, 77, 80.2, 84, 83.6, 85.9, 81.5, 70.3, 86, 76.9,
					76.5, 80, 67.8, 85.5, 81.3, 78.7, 85.9, 79.8, 80.4, 85.3, 68.9, 85.4,
					80.7, 80.5, 78.3, 85.8, 77.9, 84.2, 69.1, 66, 85.6, 81.3, 79.8, 81.2,
					77.8, 85.9, 78.6, 79.6, 79.5, 84.5, 85.7, 84.3, 81.1, 80.3, 86, 76.5,
					86.2, 76.6, 79.6, 81.1, 78.4, 79.1, 79.4, 84.5, 75.7, 81.2, 78.5,
					78.4, 84.6, 80.6, 81.2, 80.7, 78.6, 78.1, 81.1, 79.3, 84.7, 84.3,
					90.2, 78.7, 85.8, 80.6, 76.5, 79.5, 85.2, 80.8, 80.8, 85.7, 79.6,
					79.2, 84.2, 85.1, 85.3, 79.8, 80.3, 77.7, 80.4, 84.5, 76.1, 81.1,
					81.2, 78.3, 78.5, 76.6, 79.9, 84.7, 86.1, 74.2, 85.3, 77, 78.5, 79.5,
					66.8, 81.5, 78.8, 80, 79.5, 84.9, 70.7, 72.6, 81.7, 79, 77, 85.1,
					66.1, 66.9, 72.1, 81.9, 81.1, 79.1, 78.5, 76.8, 80.3, 85.1, 84.6,
					71.5, 79, 76.9, 80.5, 66.6, 70.8, 83.3, 78.3, 80.6, 80, 84.8, 66.7,
					72, 77.1, 78.8, 76.8, 85.2, 66.8, 66.4, 70.3, 77, 81.2, 79, 81, 76.9,
					81, 85.4, 84.7, 70.5, 73.4, 76.9, 77.1, 80.6, 76.9, 79, 80.7, 80.5,
					85.5, 70.6, 77,
				],
			},
			unit: null,
			avg: 78.90219435736671,
		},
		{
			name: 'SupplyTemperature',
			min: 4.22,
			max: 14.06,
			data: {
				dates: [
					'2022-11-02T23:00:20.000Z',
					'2022-11-02T23:02:13.000Z',
					'2022-11-02T23:13:52.000Z',
					'2022-11-02T23:14:44.000Z',
					'2022-11-02T23:15:12.000Z',
					'2022-11-02T23:22:23.000Z',
					'2022-11-02T23:27:40.000Z',
					'2022-11-02T23:28:08.000Z',
					'2022-11-02T23:30:20.000Z',
					'2022-11-02T23:30:48.000Z',
					'2022-11-02T23:32:13.000Z',
					'2022-11-02T23:40:32.000Z',
					'2022-11-02T23:43:52.000Z',
					'2022-11-02T23:44:20.000Z',
					'2022-11-02T23:52:23.000Z',
					'2022-11-02T23:52:51.000Z',
					'2022-11-03T00:02:13.000Z',
					'2022-11-03T00:04:23.000Z',
					'2022-11-03T00:10:32.000Z',
					'2022-11-03T00:27:40.000Z',
					'2022-11-03T00:30:20.000Z',
					'2022-11-03T00:40:32.000Z',
					'2022-11-03T00:41:41.000Z',
					'2022-11-03T00:43:52.000Z',
					'2022-11-03T00:52:23.000Z',
					'2022-11-03T00:57:40.000Z',
					'2022-11-03T01:00:20.000Z',
					'2022-11-03T01:02:13.000Z',
					'2022-11-03T01:13:52.000Z',
					'2022-11-03T01:22:23.000Z',
					'2022-11-03T01:27:40.000Z',
					'2022-11-03T01:28:08.000Z',
					'2022-11-03T01:30:20.000Z',
					'2022-11-03T01:30:48.000Z',
					'2022-11-03T01:32:13.000Z',
					'2022-11-03T01:40:32.000Z',
					'2022-11-03T01:43:52.000Z',
					'2022-11-03T01:44:20.000Z',
					'2022-11-03T01:52:23.000Z',
					'2022-11-03T01:52:51.000Z',
					'2022-11-03T02:02:13.000Z',
					'2022-11-03T02:02:21.000Z',
					'2022-11-03T02:10:32.000Z',
					'2022-11-03T02:27:40.000Z',
					'2022-11-03T02:30:20.000Z',
					'2022-11-03T02:40:32.000Z',
					'2022-11-03T02:41:41.000Z',
					'2022-11-03T02:43:52.000Z',
					'2022-11-03T02:52:23.000Z',
					'2022-11-03T02:57:40.000Z',
					'2022-11-03T03:00:20.000Z',
					'2022-11-03T03:02:13.000Z',
					'2022-11-03T03:13:52.000Z',
					'2022-11-03T03:22:23.000Z',
					'2022-11-03T03:27:40.000Z',
					'2022-11-03T03:28:08.000Z',
					'2022-11-03T03:30:20.000Z',
					'2022-11-03T03:30:48.000Z',
					'2022-11-03T03:32:13.000Z',
					'2022-11-03T03:43:52.000Z',
					'2022-11-03T03:44:20.000Z',
					'2022-11-03T03:52:23.000Z',
					'2022-11-03T03:52:51.000Z',
					'2022-11-03T04:02:13.000Z',
					'2022-11-03T04:04:23.000Z',
					'2022-11-03T04:27:40.000Z',
					'2022-11-03T04:30:20.000Z',
					'2022-11-03T04:43:52.000Z',
					'2022-11-03T04:52:23.000Z',
					'2022-11-03T04:57:40.000Z',
					'2022-11-03T05:00:20.000Z',
					'2022-11-03T05:02:13.000Z',
					'2022-11-03T05:13:52.000Z',
					'2022-11-03T05:22:23.000Z',
					'2022-11-03T05:27:40.000Z',
					'2022-11-03T05:28:08.000Z',
					'2022-11-03T05:30:20.000Z',
					'2022-11-03T05:30:48.000Z',
					'2022-11-03T05:32:13.000Z',
					'2022-11-03T05:40:32.000Z',
					'2022-11-03T05:43:52.000Z',
					'2022-11-03T05:44:20.000Z',
					'2022-11-03T05:52:23.000Z',
					'2022-11-03T05:52:51.000Z',
					'2022-11-03T06:02:13.000Z',
					'2022-11-03T06:04:23.000Z',
					'2022-11-03T06:10:32.000Z',
					'2022-11-03T06:14:44.000Z',
					'2022-11-03T06:27:40.000Z',
					'2022-11-03T06:30:20.000Z',
					'2022-11-03T06:40:32.000Z',
					'2022-11-03T06:41:41.000Z',
					'2022-11-03T06:43:52.000Z',
					'2022-11-03T06:44:44.000Z',
					'2022-11-03T06:52:23.000Z',
					'2022-11-03T06:57:40.000Z',
					'2022-11-03T07:00:20.000Z',
					'2022-11-03T07:02:13.000Z',
					'2022-11-03T07:13:52.000Z',
					'2022-11-03T07:14:44.000Z',
					'2022-11-03T07:15:12.000Z',
					'2022-11-03T07:22:23.000Z',
					'2022-11-03T07:27:40.000Z',
					'2022-11-03T07:28:08.000Z',
					'2022-11-03T07:30:20.000Z',
					'2022-11-03T07:30:48.000Z',
					'2022-11-03T07:32:13.000Z',
					'2022-11-03T07:40:32.000Z',
					'2022-11-03T07:43:52.000Z',
					'2022-11-03T07:44:20.000Z',
					'2022-11-03T07:52:23.000Z',
					'2022-11-03T07:52:51.000Z',
					'2022-11-03T08:02:13.000Z',
					'2022-11-03T08:10:32.000Z',
					'2022-11-03T08:27:40.000Z',
					'2022-11-03T08:30:20.000Z',
					'2022-11-03T08:32:13.000Z',
					'2022-11-03T08:40:32.000Z',
					'2022-11-03T08:41:41.000Z',
					'2022-11-03T08:43:52.000Z',
					'2022-11-03T08:52:23.000Z',
					'2022-11-03T08:57:40.000Z',
					'2022-11-03T09:00:20.000Z',
					'2022-11-03T09:02:13.000Z',
					'2022-11-03T09:13:52.000Z',
					'2022-11-03T09:22:23.000Z',
					'2022-11-03T09:27:40.000Z',
					'2022-11-03T09:28:08.000Z',
					'2022-11-03T09:30:20.000Z',
					'2022-11-03T09:30:48.000Z',
					'2022-11-03T09:32:13.000Z',
					'2022-11-03T09:40:32.000Z',
					'2022-11-03T09:43:52.000Z',
					'2022-11-03T09:44:20.000Z',
					'2022-11-03T09:52:23.000Z',
					'2022-11-03T10:02:13.000Z',
					'2022-11-03T10:04:23.000Z',
					'2022-11-03T10:10:32.000Z',
					'2022-11-03T10:22:23.000Z',
					'2022-11-03T10:27:40.000Z',
					'2022-11-03T10:30:20.000Z',
					'2022-11-03T10:40:32.000Z',
					'2022-11-03T10:41:41.000Z',
					'2022-11-03T10:43:52.000Z',
					'2022-11-03T10:52:23.000Z',
					'2022-11-03T10:57:40.000Z',
					'2022-11-03T11:00:20.000Z',
					'2022-11-03T11:02:13.000Z',
					'2022-11-03T11:13:52.000Z',
					'2022-11-03T11:22:23.000Z',
					'2022-11-03T11:27:40.000Z',
					'2022-11-03T11:28:08.000Z',
					'2022-11-03T11:30:20.000Z',
					'2022-11-03T11:30:31.000Z',
					'2022-11-03T11:30:48.000Z',
					'2022-11-03T11:32:13.000Z',
					'2022-11-03T11:40:32.000Z',
					'2022-11-03T11:43:52.000Z',
					'2022-11-03T11:44:20.000Z',
					'2022-11-03T11:45:31.000Z',
					'2022-11-03T11:52:23.000Z',
					'2022-11-03T11:52:51.000Z',
					'2022-11-03T12:00:31.000Z',
					'2022-11-03T12:02:13.000Z',
					'2022-11-03T12:03:22.000Z',
					'2022-11-03T12:10:32.000Z',
					'2022-11-03T12:14:44.000Z',
					'2022-11-03T12:15:31.000Z',
					'2022-11-03T12:27:40.000Z',
					'2022-11-03T12:30:20.000Z',
					'2022-11-03T12:30:31.000Z',
					'2022-11-03T12:40:32.000Z',
					'2022-11-03T12:41:41.000Z',
					'2022-11-03T12:43:52.000Z',
					'2022-11-03T12:44:44.000Z',
					'2022-11-03T12:45:31.000Z',
					'2022-11-03T12:52:23.000Z',
					'2022-11-03T12:57:40.000Z',
					'2022-11-03T13:00:20.000Z',
					'2022-11-03T13:00:31.000Z',
					'2022-11-03T13:02:13.000Z',
					'2022-11-03T13:13:52.000Z',
					'2022-11-03T13:14:44.000Z',
					'2022-11-03T13:15:12.000Z',
					'2022-11-03T13:15:31.000Z',
					'2022-11-03T13:22:23.000Z',
					'2022-11-03T13:27:40.000Z',
					'2022-11-03T13:28:08.000Z',
					'2022-11-03T13:30:20.000Z',
					'2022-11-03T13:30:31.000Z',
					'2022-11-03T13:30:48.000Z',
					'2022-11-03T13:32:13.000Z',
					'2022-11-03T13:40:32.000Z',
					'2022-11-03T13:43:52.000Z',
					'2022-11-03T13:45:31.000Z',
					'2022-11-03T13:45:44.000Z',
					'2022-11-03T13:52:23.000Z',
					'2022-11-03T13:52:51.000Z',
					'2022-11-03T14:00:31.000Z',
					'2022-11-03T14:02:13.000Z',
					'2022-11-03T14:02:35.000Z',
					'2022-11-03T14:03:22.000Z',
					'2022-11-03T14:10:32.000Z',
					'2022-11-03T14:27:40.000Z',
					'2022-11-03T14:30:20.000Z',
					'2022-11-03T14:40:32.000Z',
					'2022-11-03T14:41:41.000Z',
					'2022-11-03T14:43:52.000Z',
					'2022-11-03T14:52:23.000Z',
					'2022-11-03T14:57:40.000Z',
					'2022-11-03T15:00:20.000Z',
					'2022-11-03T15:02:13.000Z',
					'2022-11-03T15:13:52.000Z',
					'2022-11-03T15:22:23.000Z',
					'2022-11-03T15:27:40.000Z',
					'2022-11-03T15:28:08.000Z',
					'2022-11-03T15:30:20.000Z',
					'2022-11-03T15:30:48.000Z',
					'2022-11-03T15:32:13.000Z',
					'2022-11-03T15:40:32.000Z',
					'2022-11-03T15:43:52.000Z',
					'2022-11-03T15:45:01.000Z',
					'2022-11-03T15:52:23.000Z',
					'2022-11-03T15:52:31.000Z',
					'2022-11-03T16:00:31.000Z',
					'2022-11-03T16:02:13.000Z',
					'2022-11-03T16:03:22.000Z',
					'2022-11-03T16:10:32.000Z',
					'2022-11-03T16:15:31.000Z',
					'2022-11-03T16:27:40.000Z',
					'2022-11-03T16:30:20.000Z',
					'2022-11-03T16:30:31.000Z',
					'2022-11-03T16:40:32.000Z',
					'2022-11-03T16:41:41.000Z',
					'2022-11-03T16:43:52.000Z',
					'2022-11-03T16:45:31.000Z',
					'2022-11-03T16:48:46.000Z',
					'2022-11-03T16:52:23.000Z',
					'2022-11-03T16:57:40.000Z',
					'2022-11-03T17:00:20.000Z',
					'2022-11-03T17:02:13.000Z',
					'2022-11-03T17:13:52.000Z',
					'2022-11-03T17:22:23.000Z',
					'2022-11-03T17:27:40.000Z',
					'2022-11-03T17:28:08.000Z',
					'2022-11-03T17:30:20.000Z',
					'2022-11-03T17:30:48.000Z',
					'2022-11-03T17:32:13.000Z',
					'2022-11-03T17:40:32.000Z',
					'2022-11-03T17:43:52.000Z',
					'2022-11-03T17:45:01.000Z',
					'2022-11-03T17:52:23.000Z',
					'2022-11-03T17:52:31.000Z',
					'2022-11-03T18:02:13.000Z',
					'2022-11-03T18:03:22.000Z',
					'2022-11-03T18:10:32.000Z',
					'2022-11-03T18:14:44.000Z',
					'2022-11-03T18:27:40.000Z',
					'2022-11-03T18:30:20.000Z',
					'2022-11-03T18:40:32.000Z',
					'2022-11-03T18:41:41.000Z',
					'2022-11-03T18:43:52.000Z',
					'2022-11-03T18:44:44.000Z',
					'2022-11-03T18:52:23.000Z',
					'2022-11-03T18:57:40.000Z',
					'2022-11-03T19:00:20.000Z',
					'2022-11-03T19:02:13.000Z',
					'2022-11-03T19:13:52.000Z',
					'2022-11-03T19:14:44.000Z',
					'2022-11-03T19:15:12.000Z',
					'2022-11-03T19:22:23.000Z',
					'2022-11-03T19:27:40.000Z',
					'2022-11-03T19:28:08.000Z',
					'2022-11-03T19:30:20.000Z',
					'2022-11-03T19:30:48.000Z',
					'2022-11-03T19:32:13.000Z',
					'2022-11-03T19:40:32.000Z',
					'2022-11-03T19:43:52.000Z',
					'2022-11-03T19:45:01.000Z',
					'2022-11-03T19:52:23.000Z',
					'2022-11-03T20:02:13.000Z',
					'2022-11-03T20:03:22.000Z',
					'2022-11-03T20:10:32.000Z',
					'2022-11-03T20:14:44.000Z',
					'2022-11-03T20:22:23.000Z',
					'2022-11-03T20:27:40.000Z',
					'2022-11-03T20:30:20.000Z',
					'2022-11-03T20:40:32.000Z',
					'2022-11-03T20:41:41.000Z',
					'2022-11-03T20:43:52.000Z',
					'2022-11-03T20:44:44.000Z',
					'2022-11-03T20:52:23.000Z',
					'2022-11-03T20:57:40.000Z',
					'2022-11-03T21:00:20.000Z',
					'2022-11-03T21:02:13.000Z',
					'2022-11-03T21:13:52.000Z',
					'2022-11-03T21:14:44.000Z',
					'2022-11-03T21:15:12.000Z',
					'2022-11-03T21:22:23.000Z',
					'2022-11-03T21:27:40.000Z',
					'2022-11-03T21:28:08.000Z',
					'2022-11-03T21:30:20.000Z',
					'2022-11-03T21:30:48.000Z',
					'2022-11-03T21:32:13.000Z',
					'2022-11-03T21:40:32.000Z',
					'2022-11-03T21:43:52.000Z',
					'2022-11-03T21:45:01.000Z',
					'2022-11-03T21:52:23.000Z',
					'2022-11-03T21:53:32.000Z',
					'2022-11-03T22:02:13.000Z',
					'2022-11-03T22:03:22.000Z',
					'2022-11-03T22:10:32.000Z',
					'2022-11-03T22:27:40.000Z',
					'2022-11-03T22:30:20.000Z',
					'2022-11-03T22:40:32.000Z',
					'2022-11-03T22:41:20.000Z',
					'2022-11-03T22:43:52.000Z',
					'2022-11-03T22:52:23.000Z',
					'2022-11-03T22:57:40.000Z',
				],
				values: [
					-14.78, -14.38, -14.78, -13.67, -13.73, -12.19, -14.11, -14.13,
					-14.69, -14.78, -14.44, -15.09, -14.88, -14.91, -12.22, -12.07,
					-14.54, -14.51, -14.94, -14.23, -14.78, -14.94, -15.03, -14.97,
					-13.09, -14.23, -14.82, -14.57, -15, -12.9, -14.26, -14.2, -14.82,
					-14.76, -14.6, -15.16, -15, -14.94, -12.56, -12.93, -14.63, -14.51,
					-15.22, -14.07, -14.82, -15.24, -15.09, -14.91, -13.43, -14.2, -14.76,
					-14.6, -14.97, -13.58, -14.29, -14.26, -14.82, -14.82, -14.63, -15.03,
					-15.03, -13.55, -12.99, -14.66, -14.51, -14.32, -14.88, -15.09, -12.5,
					-14.32, -14.88, -14.66, -15.12, -11.94, -14.32, -14.29, -14.91,
					-14.82, -14.69, -15.37, -15.12, -15.06, -11.67, -13.21, -14.6, -14.63,
					-15.37, -13.95, -14.32, -14.78, -15.4, -15.34, -15.09, -13.95, -11.36,
					-14.35, -14.84, -14.72, -15.12, -13.98, -13.86, -11.23, -14.35,
					-14.17, -14.88, -14.88, -14.76, -15.37, -15.16, -15, -11.14, -11.48,
					-14.76, -15.4, -14.41, -14.91, -14.76, -15.43, -15.24, -15.18, -12.1,
					-14.41, -14.88, -14.76, -15.12, -12.26, -14.2, -14.38, -14.84, -14.91,
					-14.63, -15.43, -15.03, -15.18, -12.1, -14.69, -14.63, -15.31, -11.88,
					-14.32, -14.76, -15.12, -15.4, -15.09, -11.85, -14.32, -14.78, -14.69,
					-15.12, -11.88, -14.35, -14.29, -14.76, -10.03, -14.72, -14.69,
					-14.94, -15.12, -15.09, -10, -11.88, -11.02, -10.06, -14.69, -14.66,
					-14.91, -13.55, -10.03, -14.38, -14.78, -10.09, -14.88, -14.97,
					-14.97, -13.58, -10.06, -11.98, -14.23, -14.72, -10.09, -14.57,
					-14.97, -13.58, -13.46, -10.06, -12.04, -14.17, -14.35, -14.66,
					-10.12, -14.76, -14.63, -14.82, -15, -10.09, -15.09, -12.04, -11.91,
					-10.12, -14.66, -9.97, -14.66, -14.82, -14.32, -14.72, -14.76, -14.84,
					-15, -13.3, -14.32, -14.72, -14.69, -15, -13.86, -14.35, -14.29,
					-14.78, -14.72, -14.63, -14.76, -15, -15, -12.26, -12.53, -10.12,
					-14.6, -14.66, -14.78, -10.09, -14.32, -14.69, -10.16, -14.82, -14.72,
					-14.91, -10.09, -10.09, -11.29, -14.26, -14.66, -14.54, -14.97,
					-11.05, -14.32, -14.35, -14.76, -14.76, -14.63, -14.78, -14.97,
					-14.84, -10.89, -11.63, -14.66, -14.48, -14.78, -13.73, -14.38,
					-14.78, -14.78, -14.78, -15, -13.49, -10.74, -14.41, -14.82, -14.72,
					-15.03, -13.64, -13.67, -10.65, -14.44, -14.35, -14.78, -14.78,
					-14.72, -14.82, -14.94, -14.97, -10.49, -14.54, -14.66, -14.82,
					-13.77, -10.37, -14.29, -14.78, -14.82, -14.78, -15, -13.77, -10.34,
					-14.38, -14.84, -14.72, -15.03, -13.79, -13.73, -10.34, -14.57,
					-14.41, -14.84, -14.69, -14.76, -14.72, -15.06, -14.88, -10.34,
					-10.77, -14.78, -14.6, -14.76, -14.63, -14.84, -14.78, -14.82, -15.09,
					-10.34, -14.63,
				],
			},
			unit: 'F',
			avg: 6.781347962382442,
		},
		{
			name: 'Location',
			min: null,
			max: null,
			data: {
				dates: [
					'2022-11-02T23:00:39.000Z',
					'2022-11-02T23:15:12.000Z',
					'2022-11-02T23:28:08.000Z',
					'2022-11-02T23:30:39.000Z',
					'2022-11-02T23:30:48.000Z',
					'2022-11-02T23:44:20.000Z',
					'2022-11-02T23:52:51.000Z',
					'2022-11-03T00:00:39.000Z',
					'2022-11-03T00:04:23.000Z',
					'2022-11-03T00:30:39.000Z',
					'2022-11-03T00:41:41.000Z',
					'2022-11-03T01:00:39.000Z',
					'2022-11-03T01:28:08.000Z',
					'2022-11-03T01:30:39.000Z',
					'2022-11-03T01:30:48.000Z',
					'2022-11-03T01:44:20.000Z',
					'2022-11-03T01:52:51.000Z',
					'2022-11-03T02:00:39.000Z',
					'2022-11-03T02:02:21.000Z',
					'2022-11-03T02:30:39.000Z',
					'2022-11-03T02:41:41.000Z',
					'2022-11-03T03:00:39.000Z',
					'2022-11-03T03:28:08.000Z',
					'2022-11-03T03:30:39.000Z',
					'2022-11-03T03:30:48.000Z',
					'2022-11-03T03:44:20.000Z',
					'2022-11-03T03:52:51.000Z',
					'2022-11-03T04:04:23.000Z',
					'2022-11-03T04:30:39.000Z',
					'2022-11-03T05:00:39.000Z',
					'2022-11-03T05:28:08.000Z',
					'2022-11-03T05:30:39.000Z',
					'2022-11-03T05:30:48.000Z',
					'2022-11-03T05:44:20.000Z',
					'2022-11-03T05:52:51.000Z',
					'2022-11-03T06:04:23.000Z',
					'2022-11-03T06:41:41.000Z',
					'2022-11-03T07:00:39.000Z',
					'2022-11-03T07:15:12.000Z',
					'2022-11-03T07:28:08.000Z',
					'2022-11-03T07:30:39.000Z',
					'2022-11-03T07:30:48.000Z',
					'2022-11-03T07:44:20.000Z',
					'2022-11-03T07:52:51.000Z',
					'2022-11-03T08:30:39.000Z',
					'2022-11-03T08:41:41.000Z',
					'2022-11-03T09:00:39.000Z',
					'2022-11-03T09:28:08.000Z',
					'2022-11-03T09:30:39.000Z',
					'2022-11-03T09:30:48.000Z',
					'2022-11-03T09:44:20.000Z',
					'2022-11-03T10:00:39.000Z',
					'2022-11-03T10:04:23.000Z',
					'2022-11-03T10:41:41.000Z',
					'2022-11-03T11:28:08.000Z',
					'2022-11-03T11:30:48.000Z',
					'2022-11-03T11:30:59.000Z',
					'2022-11-03T11:44:20.000Z',
					'2022-11-03T11:52:51.000Z',
					'2022-11-03T12:00:39.000Z',
					'2022-11-03T12:03:22.000Z',
					'2022-11-03T12:30:39.000Z',
					'2022-11-03T12:41:41.000Z',
					'2022-11-03T13:00:39.000Z',
					'2022-11-03T13:15:12.000Z',
					'2022-11-03T13:28:08.000Z',
					'2022-11-03T13:30:48.000Z',
					'2022-11-03T13:45:44.000Z',
					'2022-11-03T13:52:51.000Z',
					'2022-11-03T14:02:35.000Z',
					'2022-11-03T14:03:22.000Z',
					'2022-11-03T14:30:59.000Z',
					'2022-11-03T14:41:41.000Z',
					'2022-11-03T15:28:08.000Z',
					'2022-11-03T15:30:48.000Z',
					'2022-11-03T15:45:01.000Z',
					'2022-11-03T15:52:31.000Z',
					'2022-11-03T16:00:59.000Z',
					'2022-11-03T16:03:22.000Z',
					'2022-11-03T16:41:41.000Z',
					'2022-11-03T16:48:46.000Z',
					'2022-11-03T17:28:08.000Z',
					'2022-11-03T17:30:48.000Z',
					'2022-11-03T17:45:01.000Z',
					'2022-11-03T17:52:31.000Z',
					'2022-11-03T18:03:22.000Z',
					'2022-11-03T18:30:59.000Z',
					'2022-11-03T18:41:41.000Z',
					'2022-11-03T19:15:12.000Z',
					'2022-11-03T19:28:08.000Z',
					'2022-11-03T19:30:48.000Z',
					'2022-11-03T19:45:01.000Z',
					'2022-11-03T20:03:22.000Z',
					'2022-11-03T20:41:41.000Z',
					'2022-11-03T21:15:12.000Z',
					'2022-11-03T21:28:08.000Z',
					'2022-11-03T21:30:48.000Z',
					'2022-11-03T21:45:01.000Z',
					'2022-11-03T21:53:32.000Z',
					'2022-11-03T22:03:22.000Z',
					'2022-11-03T22:41:20.000Z',
				],
				values: [
					[51.952955, 4.232112],
					[30.4303729852941, -9.63260089705882],
					[30.4347122183908, -9.63764631034483],
					[51.952955, 4.232112],
					[30.4335443090909, -9.63640473636364],
					[30.4337734237288, -9.63661361016949],
					[31.7268178457711, -8.21892035820896],
					[51.952955, 4.232112],
					[30.440671, -9.644614],
					[51.952955, 4.232112],
					[30.4323656923077, -9.63949108974359],
					[51.952955, 4.232112],
					[30.4345481262136, -9.63740822330097],
					[51.952955, 4.232112],
					[30.4367763773585, -9.63432795283019],
					[30.4345348039216, -9.6378221372549],
					[31.7355491098901, -8.20329932967033],
					[51.952955, 4.232112],
					[30.440671, -9.644614],
					[51.952955, 4.232112],
					[30.4322627471264, -9.63937187356322],
					[51.952955, 4.232112],
					[30.4377333636364, -9.63424901136364],
					[51.952955, 4.232112],
					[30.4374782542373, -9.63557838983051],
					[30.4336312, -9.63644369230769],
					[32.2518478449198, -7.9671977459893],
					[30.43584555, -9.639373325],
					[51.952955, 4.232112],
					[51.952955, 4.232112],
					[30.4333403548387, -9.63609744086021],
					[51.952955, 4.232112],
					[30.4335691938775, -9.63645019387755],
					[30.4332895797101, -9.63601052173913],
					[33.0715879954338, -7.59558210045662],
					[30.440671, -9.644614],
					[30.4319070493827, -9.63945818518519],
					[51.952955, 4.232112],
					[30.4330055, -9.6359498125],
					[30.4339412368421, -9.63697955263158],
					[51.954255, 4.240674],
					[30.4339960222222, -9.63705042222222],
					[30.43345575, -9.63624947222222],
					[33.8308806178571, -7.10037751785714],
					[51.954255, 4.240674],
					[30.4342404098361, -9.642593],
					[51.952955, 4.232112],
					[30.4339185802469, -9.6368142962963],
					[51.954255, 4.240674],
					[30.4335586272727, -9.6364809],
					[30.4334528030303, -9.63627857575758],
					[51.954255, 4.240674],
					[30.427211, -9.640919],
					[30.4349114150943, -9.64440537735849],
					[30.4338630394737, -9.63673182894737],
					[30.4338021348315, -9.63681646067416],
					[51.952955, 4.232112],
					[30.4336251029412, -9.63649625],
					[35.883972, -5.473394],
					[51.954255, 4.240674],
					[30.427211, -9.640919],
					[51.954255, 4.240674],
					[30.4328541724138, -9.63979547126437],
					[51.954255, 4.240674],
					[30.4332148, -9.63619068571428],
					[30.4335544946237, -9.63634035483871],
					[30.4369392481752, -9.63524077372263],
					[30.4333946666667, -9.64371866666667],
					[35.8844292424242, -5.49402397402597],
					[51.951598, 4.237888],
					[30.427211, -9.640919],
					[51.951598, 4.237888],
					[30.4330865164835, -9.63967716483516],
					[30.433583125, -9.63635879545454],
					[30.4334720521739, -9.63631486086956],
					[30.4325411428571, -9.64069549350649],
					[35.870845, -5.520491],
					[51.951598, 4.237888],
					[30.427211, -9.640919],
					[30.4331279350649, -9.64034220779221],
					[51.951598, 4.237888],
					[30.4336610506329, -9.63659812658228],
					[30.433855245283, -9.63681716981132],
					[30.433902942029, -9.64062105797101],
					[35.870845, -5.520491],
					[30.4282446, -9.6367858],
					[51.951598, 4.237888],
					[30.4334705810811, -9.64066121621622],
					[30.4343815283019, -9.63686075471698],
					[30.4331905348837, -9.63595588372093],
					[30.43358004, -9.63650266],
					[30.4340352345679, -9.64201290123457],
					[30.427211, -9.640919],
					[30.4286600888889, -9.63804202222222],
					[30.4303234576271, -9.63255413559322],
					[30.4340390875, -9.6368595],
					[30.433044875, -9.63448934166667],
					[30.4345469885057, -9.64242155172414],
					[36.09004964, -5.42138086666667],
					[30.427211, -9.640919],
					[30.427211, -9.640919],
				],
			},
		},
		{
			name: 'Light',
			min: 0,
			max: 0,
			data: {
				dates: [
					'2022-11-02T23:15:12.000Z',
					'2022-11-02T23:28:08.000Z',
					'2022-11-02T23:30:48.000Z',
					'2022-11-02T23:44:20.000Z',
					'2022-11-02T23:52:51.000Z',
					'2022-11-03T00:04:23.000Z',
					'2022-11-03T00:41:41.000Z',
					'2022-11-03T01:28:08.000Z',
					'2022-11-03T01:30:48.000Z',
					'2022-11-03T01:44:20.000Z',
					'2022-11-03T01:52:51.000Z',
					'2022-11-03T02:02:21.000Z',
					'2022-11-03T02:41:41.000Z',
					'2022-11-03T03:28:08.000Z',
					'2022-11-03T03:30:48.000Z',
					'2022-11-03T03:44:20.000Z',
					'2022-11-03T03:52:51.000Z',
					'2022-11-03T04:04:23.000Z',
					'2022-11-03T05:28:08.000Z',
					'2022-11-03T05:30:48.000Z',
					'2022-11-03T05:44:20.000Z',
					'2022-11-03T05:52:51.000Z',
					'2022-11-03T06:04:23.000Z',
					'2022-11-03T06:41:41.000Z',
					'2022-11-03T07:15:12.000Z',
					'2022-11-03T07:28:08.000Z',
					'2022-11-03T07:30:48.000Z',
					'2022-11-03T07:44:20.000Z',
					'2022-11-03T07:52:51.000Z',
					'2022-11-03T08:41:41.000Z',
					'2022-11-03T09:28:08.000Z',
					'2022-11-03T09:30:48.000Z',
					'2022-11-03T09:44:20.000Z',
					'2022-11-03T10:02:13.000Z',
					'2022-11-03T10:04:23.000Z',
					'2022-11-03T10:41:41.000Z',
					'2022-11-03T11:28:08.000Z',
					'2022-11-03T11:30:48.000Z',
					'2022-11-03T11:44:20.000Z',
					'2022-11-03T11:52:23.000Z',
					'2022-11-03T11:52:51.000Z',
					'2022-11-03T12:00:31.000Z',
					'2022-11-03T12:03:22.000Z',
					'2022-11-03T12:30:31.000Z',
					'2022-11-03T12:41:41.000Z',
					'2022-11-03T13:00:31.000Z',
					'2022-11-03T13:15:12.000Z',
					'2022-11-03T13:28:08.000Z',
					'2022-11-03T13:30:31.000Z',
					'2022-11-03T13:30:48.000Z',
					'2022-11-03T13:45:44.000Z',
					'2022-11-03T13:52:51.000Z',
					'2022-11-03T14:00:31.000Z',
					'2022-11-03T14:02:35.000Z',
					'2022-11-03T14:03:22.000Z',
					'2022-11-03T14:41:41.000Z',
					'2022-11-03T15:28:08.000Z',
					'2022-11-03T15:30:48.000Z',
					'2022-11-03T15:45:01.000Z',
					'2022-11-03T15:52:31.000Z',
					'2022-11-03T16:03:22.000Z',
					'2022-11-03T16:30:31.000Z',
					'2022-11-03T16:41:41.000Z',
					'2022-11-03T16:48:46.000Z',
					'2022-11-03T17:28:08.000Z',
					'2022-11-03T17:30:48.000Z',
					'2022-11-03T17:45:01.000Z',
					'2022-11-03T17:52:31.000Z',
					'2022-11-03T18:03:22.000Z',
					'2022-11-03T18:41:41.000Z',
					'2022-11-03T19:15:12.000Z',
					'2022-11-03T19:28:08.000Z',
					'2022-11-03T19:30:48.000Z',
					'2022-11-03T19:45:01.000Z',
					'2022-11-03T20:03:22.000Z',
					'2022-11-03T20:41:41.000Z',
					'2022-11-03T21:15:12.000Z',
					'2022-11-03T21:28:08.000Z',
					'2022-11-03T21:30:48.000Z',
					'2022-11-03T21:45:01.000Z',
					'2022-11-03T21:52:23.000Z',
					'2022-11-03T21:53:32.000Z',
					'2022-11-03T22:03:22.000Z',
					'2022-11-03T22:41:20.000Z',
				],
				values: [
					0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
					0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
					0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
					0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
				],
			},
			unit: null,
			avg: 0,
		},
	],
};
